import React from 'react';
import { Link } from 'react-router-dom';
import { Row, Col } from 'reactstrap';
import { useTranslation } from 'react-i18next';
import './PartnerDemoPages.css';

const DEMO_STATS = [
  { title: 'Compliance status', value: 'Compliant', sub: 'Last assessed Jan 2025', success: true },
  { title: 'Questionnaires', value: '3', sub: 'Completed' },
  { title: 'Documents', value: '8', sub: 'Certificates uploaded' },
  { title: 'Assessment requests', value: '2', sub: 'Pending' },
];

const DEMO_ACTIVITY = [
  { id: 1, text: 'QCB questionnaire completed and submitted', time: '2 hours ago' },
  { id: 2, text: 'ISO 27001 certificate uploaded', time: '1 day ago' },
  { id: 3, text: 'Assessment request from Gulf Bank – in progress', time: '2 days ago' },
];

const QUICK_LINKS = [
  { to: '/demo-partner/questionnaires', label: 'Questionnaires' },
  { to: '/demo-partner/documents', label: 'Documents & certificates' },
  { to: '/demo-partner/status', label: 'Compliance status' },
  { to: '/demo-partner/tickets', label: 'Tickets & findings' },
  { to: '/demo-partner/certifications', label: 'Certifications' },
  { to: '/demo-partner/assessment-requests', label: 'Assessment requests' },
  { to: '/demo-partner/profile', label: 'Partner profile' },
  { to: '/demo-partner/visibility', label: 'Visibility' },
];

const DemoDashboard: React.FC = () => {
  const { t } = useTranslation();

  return (
    <div className="partner-demo-page">
      <nav className="page-breadcrumb">
        <Link to="/">Home</Link>
        <span className="mx-2">/</span>
        <span>Partner dashboard</span>
      </nav>
      <header className="page-header">
       
       
      </header>

      <Row className="mb-4 g-3">
        {DEMO_STATS.map((stat) => (
          <Col key={stat.title} sm="6" lg="3">
            <div className={`stat-card ${stat.success ? 'stat-success' : ''}`}>
              <div className="stat-label">{stat.title}</div>
              <div className="stat-value">{stat.value}</div>
              <div className="stat-meta">{stat.sub}</div>
            </div>
          </Col>
        ))}
      </Row>

      <Row>
        <Col lg="8" className="mb-4">
          <div className="card-partner">
            <div className="card-header-partner">Recent activity</div>
            <div className="card-body-partner">
              {DEMO_ACTIVITY.map((a) => (
                <div key={a.id} className="activity-item">
                  <div>{a.text}</div>
                  <div className="activity-time">{a.time}</div>
                </div>
              ))}
            </div>
          </div>
        </Col>
        <Col lg="4">
          <div className="card-partner">
            <div className="card-header-partner">Quick actions</div>
            <div className="card-body-partner">
              {QUICK_LINKS.map((link) => (
                <Link key={link.to} to={link.to} className="quick-link-card d-block">
                  {link.label}
                </Link>
              ))}
            </div>
          </div>
        </Col>
      </Row>
    </div>
  );
};

export default DemoDashboard;
